// src/components/common/StepStatusBanner.js
import React from "react";
import { Alert, Box, Chip, Stack, Typography } from "@mui/material";

const STATUS = {
  empty: { label: "Not started", color: "default" },
  draft: { label: "Draft — not confirmed", color: "default" },
  proposed: { label: "Proposed — please review", color: "warning" },
  confirmed: { label: "Confirmed", color: "success" },
  stale: { label: "Needs to be redone", color: "error" },
};

export function StepStatusChip({ status }) {
  const s = STATUS[status] || STATUS.empty;
  return <Chip size="small" color={s.color} variant={status === "confirmed" ? "filled" : "outlined"} label={s.label} />;
}

/** Explains a stale step: an earlier answer changed after this step was done. */
export function StaleBanner({ status, step }) {
  if (status !== "stale") return null;
  const what = step === 5 ? "Generate new suggestions" : step === 6 ? "Review your selection against the new suggestions and confirm again"
    : "Generate the teaching plan again (or review it) and confirm";
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      You changed an earlier step after this one was done, so this result may no longer fit. {what}.
    </Alert>
  );
}

export function StepHistory({ history }) {
  if (!history?.length) return null;
  const label = { saved: "edited", proposed: "proposed", confirmed: "confirmed", generated: "generated", stale: "marked to redo" };
  const who = { user: "you", assistant: "your assistant", llm: "the tool's AI", system: "the tool" };
  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary">
        History:{" "}
        {history.slice(-4).map((h, i) => (
          <span key={i}>{i ? " · " : ""}{label[h.action] || h.action} by {who[h.source] || h.source}</span>
        ))}
      </Typography>
    </Box>
  );
}

export function StepHeaderMeta({ view }) {
  if (!view) return null;
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }} flexWrap="wrap">
      <StepStatusChip status={view.status} />
      <StepHistory history={view.history} />
    </Stack>
  );
}
